import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { userCloseUserBlockModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { UserBlockForm } from './components'
// styles
import { styles } from './styles'

type UserBlockCardProps = {}

export const UserBlockCard: FC<UserBlockCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const userBlockError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile onCloseClick={() => dispatch(userCloseUserBlockModal())} />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Block User" icon={icons.AlertTriangle} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Are you sure you want to block this user?" />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <UserBlockForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={userBlockError} />
        </div>
      </div>
    </div>
  )
}

UserBlockCard.propTypes = {}
